import { useState } from 'react';
import type { Period } from 'components/shared/DateNavigation';
import { getDefaultHoursPayOutPeriod } from '../HoursPayOutRequestsOverview.const';

export const usePeriodAndDateState = () => {
  'use memo';

  const [period, setPeriod] = useState<Period>('custom');
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    () => new Date()
  );
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Date | null, Date | null]
  >(getDefaultHoursPayOutPeriod);

  return {
    period,
    setPeriod,
    selectedDate,
    setSelectedDate,
    selectedDateRange,
    setSelectedDateRange
  };
};
